/* eslint-disable import/no-default-export */
import {
  ButtonSizes,
  PrimaryButton,
  DangerButton,
} from 'app/common/components/controls/button/button';
import { forNamespace } from 'app/common/lib/util/i18n';
import React from 'react';

import styles from './popover-confirm.less';
import { StringSubstitutions } from 'app/common/lib/util/i18n/babble';

export interface PopoverConfirmProps {
  confirmKey: string;
  confirmCallback: React.MouseEventHandler;
  confirmSubstitutions?: StringSubstitutions;
  isDanger?: boolean;
}

const PopoverConfirm: React.FunctionComponent<PopoverConfirmProps> = ({
  confirmKey,
  confirmCallback,
  confirmSubstitutions,
  isDanger,
}) => {
  const format = forNamespace(['confirm', confirmKey]);
  const ActionButton = isDanger ? DangerButton : PrimaryButton;

  return (
    <div className={styles.confirmContainer}>
      <p>{format('text', confirmSubstitutions)}</p>

      <ActionButton
        autoFocus
        onClick={confirmCallback}
        size={ButtonSizes.FULLWIDTH}
      >
        {format('confirm', confirmSubstitutions)}
      </ActionButton>
    </div>
  );
};

export default PopoverConfirm;
